// extracted by mini-css-extract-plugin
module.exports = {"info":"tweet-info_info__ll_kH","infoLink":"tweet-info_infoLink__xdgYO","infoIcon":"tweet-info_infoIcon__S8lzA"};